import '@/App.css';
import OceanDescent from '@/pages/OceanDescent';

function App() {
  return <OceanDescent />;
}

export default App;
